<template>
    <div v-if="currentCategory && currentCategory.children" class="category__sub-cats">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="category in currentCategory.children" v-if="category.details">

                    <a :href="category.url">
                        <div class="swiper-slide-img">
                            <img :src="'/documents/' + category.details[0].image2Path" class="img-fluid"
                                 :alt="category.details[0].name">
                        </div>
                        <div class="swiper-slide-text">{{ category.details[0].name }}</div>
                    </a>

                </div>
            </div>
        </div>
        <div class="swiper-button-next"><i class="fa fa-chevron-right"></i></div>
        <div class="swiper-button-prev"><i class="fa fa-chevron-left"></i></div>
    </div>
</template>

<script>
import ApiService from 'ceres/app/services/ApiService';
import Vuex from 'vuex';
import Swiper from 'swiper';

export default {

    props: [
        'initialCategory',
    ],
    computed: {
        ...Vuex.mapState({
            currentCategory: state => state.navigation.currentCategory,
            navigationTree: state => state.navigation.tree,
        }),
    },
    mounted() {
        this.$nextTick(() => {
            if (this.navigationTree.length <= 0) {
                /*this.$store.dispatch('loadNavigationTree').then(() => {
                    this.initNavigation();
                });*/
                this.$store.dispatch('loadPartialNavigationTree', this.currentCategory.id).then(response => {
                    this.$store.commit('setNavigationTree', response);
                    this.initNavigation();
                });
            }
        });
    },
    watch: {
        navigationTree() {
            //this.initNavigation();
        },
    },
    methods: {
        initNavigation() {
            if (this.initialCategory && this.initialCategory.id) {
                if (this.initialCategory.linklist === 'N') {
                    this.$store.commit('setCurrentCategory',
                        this.initialCategory);
                    this.$nextTick(() => {
                        this.initSlider();
                    });
                } else {
                    this.$store.dispatch('setCurrentCategoryById',
                        {categoryId: parseInt(this.initialCategory.id)}).then(() => {
                        this.initSlider();
                    });
                }
            }
        },
        initSlider() {
            let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

            if (width > 991) {
                new Swiper('.category__sub-cats .swiper-container', {
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    spaceBetween: 15,
                    loop: false,
                    slidesPerView: 6,
                    centeredSlides: false,
                });
            } else if (width < 991 && width > 568) {
                // check ob > 6 subcats
                if ($('.category__sub-cats .swiper-slide').length > 6) {
                    new Swiper('.category__sub-cats .swiper-container', {
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        spaceBetween: 15,
                        loop: false,
                        slidesPerView: 3,
                        centeredSlides: false,
                    });
                } else {
                    $('.category__sub-cats').addClass('is-mobile');
                }
            } else {
                $('.category__sub-cats').addClass('is-mobile');
            }
        },
    },
};


</script>

